import React, { Component } from 'react'
import { Contacts } from 'containers/pages'
import { AwardUnitDetail as AwardUnitDetailForm } from 'containers/forms/award-units'
import { SubTabs, SubTab } from 'components/layout'
import AwardUnitLabels from './AwardUnitLabels'
import { get } from 'lodash'
import { CONFIGURATION_KEYS } from '../../../constants/enums'
import { compose } from 'recompose'
import { apiConfiguration } from '../../../helpers/decorators/api'
import { connect } from 'react-redux'

const enhance = compose(
    apiConfiguration({
        getValues: [CONFIGURATION_KEYS.enableOrganizationLabels.id]
    }),
    connect(({ auth }) => ({
        activeOrganization: auth.organization
    }))
)
class AwardUnitDetailWrapper extends Component {
  static propTypes = {}
  static defaultProps = {}

  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
      const { activeOrganization, configuration } = this.props

      const isLabelsEnabled = get(configuration,`valuesByOrganizationId[${activeOrganization.id}][${CONFIGURATION_KEYS.enableLabels.id}].booleanValue`)

      return (
      <SubTabs>
        <SubTab title="Office details" intlKey="tabs.office_details">
          <AwardUnitDetailForm {...this.props} />
        </SubTab>
        <SubTab title="Related contacts" intlKey="tabs.related_contacts">
          <Contacts {...this.props} />
        </SubTab>
          {isLabelsEnabled &&<SubTab title="Labels" intlKey="tabs.labels">
          <AwardUnitLabels {...this.props} hideAction />
        </SubTab>}
      </SubTabs>
    )
  }
}

export default enhance(AwardUnitDetailWrapper)
